import { post } from "@utils/httpUtil";
// 查询新社区详情
export function findNewCommunityDetail(data, config) {
  return post(`/v2/hc/detail`, data, config);
}
// 保存新社区详情
export function saveNewCommunityDetail(data, config) {
  return post(`/v2/hc/insert`, data, config);
}
// 获取推广信息
export function getPromotionInfo(data, config) {
  return post(`/v2/hc/getPromotionInfo`, data, config);
}
// 获取推广信息-医学首页
export function getDCPromotionInfo(data, config) {
  return post(`/v2/dc/getPromotionInfo`, data, config);
}
// 保存linkcard-健康首页
export function saveLinkcard(data, config) {
  return post(`/v2/hc/saveLinkcard`, data, config);
}
// 保存linkcard-医生首页
export function saveDCLinkcard(data, config) {
  return post(`/v2/dc/saveLinkcard`, data, config);
}
// 获取社区认证主体信息
export function findQualificationCommunityMain(data, config) {
  return post(`/c/pc/community/findQualificationCommunityMain`, data, config);
}